<template>
  <div class="admin-home p-5 pt-0">
    <div class="bg-white">
      <div class="row align-items-center">
        <div class="col-md-6">
          <img src="@/assets/kingz-logo.png" alt style="width: 10%" />
        </div>
        <div class="col-md-6">
          <h1 class="text-end" style="font-size: 1rem">
            No. of Barber: {{ staff_number }}
          </h1>
        </div>
      </div>
    </div>
    <template v-if="tokens">
      <div class="mt-3">
        <div class="pull-left">
          <b>Last Token End Time: {{ tokens["last"] }}</b>
        </div>
        <div class="pull-right">
          <template v-for="(b, i) in bg">
            <span
              :key="i"
              :style="
                'padding:5px;border-radius:3px;color:#fff;margin-right:10px;margin-bottom:10px;background:' +
                bg[i]
              "
              >{{ textTransform(i) }}</span
            >
          </template>
        </div>
        <div class="clearfix"></div>
        <table class="table bg-grey mt-4">
          <thead style="padding: 50px">
            <tr>
              <th class="fw-bolder" scope="col">Token No.</th>
              <th class="fw-bolder" scope="col">Selected Service</th>
              <th class="fw-bolder" scope="col">Start Time</th>
              <th class="fw-bolder" scope="col">End Time</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(token, key) in tokens">
              <template v-if="key != 'completed' && key != 'last'">
                <tr
                  v-for="t of token"
                  :key="t.id"
                  :style="'background:' + bg[key]"
                >
                  <td class="fw-bold text-white">{{ t.token_number }}</td>
                  <td class="text-white">{{ t.service.title }}</td>
                  <td class="text-white">
                    {{ changeTimeToHIA(t.approach_start_time) }}
                  </td>
                  <td class="text-white">
                    {{ changeTimeToHIA(t.approach_end_time) }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>
<script>
import util from "@/util/util";
import { mapMutations } from "vuex";
export default {
  name: "DailyTokenTVScreen",

  mounted() {
    this.bindEvent();
    this.isLoading(true);
    this.getActiveStaffNumber();
    this.fetchTokens();
    console.log(this.bg.cancelled);
  },
  data() {
    return {
      tokens: null,
      staff_number: 0,
      bg: {
        current: "#237A79",
        on_queue: "#167CF3",
        on_hold: "#CE7205",
        cancelled: "#AB0606",
        // completed: "#198008"
      },
    };
  },
  methods: {
    changeTimeToHIA(val) {
      return util.changeTimeFormat(val);
    },
    textTransform(val) {
      return util.camelCase(val);
    },
    bindEvent() {
      util.bindEvent.call(this, {
        channelName: "GenerateTokenFromFrontEnd",
        eventName: "GenerateTokenFromFrontEnd",
        callback: () => {
          this.fetchTokens();
        },
      });
      util.bindEvent.call(this, {
        channelName: "ChangeTokenStatus",
        eventName: "ChangeTokenStatus",
        callback: () => {
          this.fetchTokens();
        },
      });
    },
    getActiveStaffNumber() {
      this.$http.get("/user/staff-numbers").then((res) => {
        this.isLoading(false);
        if (res.data.status == 1) {
          this.staff_number = res.data.data;
          this.$notify({
            group: "notifications",
            title: res.data.data.message,
            type: "success",
            text: res.data.message,
          });
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
        }
      });
    },
    fetchTokens() {
      this.$http.get("/token/daily/screen").then((response) => {
        this.tokens = response.data.data;
        this.isLoading(false);
      });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
  },
};
</script>

<style scoped>
.bg-white {
  /* background-color: #eee!important; */
  padding: 6px;
  border-radius: 10px;
}
.bg-white h1 {
  font-size: 1.6rem;
}

.admin-home h2 {
  font-size: 1.4rem;
}
.bg-grey {
  background: #eee;
}
.table > :not(caption) > * > * {
  padding: 0.8rem 0.8rem;
  font-size: 1.2rem;
}
</style>
